import { ACT_CODE, CAN_CODE, CLOSE_CODE, ERROR_CODE } from 'consts/global';
import { RequiredFieldsLocation } from 'models/requiredFields';
import { GA_CATEGORIES } from 'consts/analytics/ga';

export enum CATEGORIES {
  card = 'card',
  card_redirect = 'card_redirect',
  cash = 'cash',
  ewallet = 'ewallet',
  bank = 'bank',
  bank_redirect = 'bank_redirect',
  bank_transfer = 'bank_transfer'
}

export const categoryMapping = {
  [CATEGORIES.card]: 'card',
  [CATEGORIES.card_redirect]: 'card',
  [CATEGORIES.cash]: 'cash',
  [CATEGORIES.ewallet]: 'ewallet',
  [CATEGORIES.bank]: 'bank',
  [CATEGORIES.bank_redirect]: 'bank',
  [CATEGORIES.bank_transfer]: 'bank'
};

export const TABS_SELECT_TEXT = {
  [CATEGORIES.card]: 'select_card',
  [CATEGORIES.cash]: 'select_cash',
  [CATEGORIES.ewallet]: 'select_wallet',
  [CATEGORIES.bank]: 'select_bank'
};

export const THANK_YOU_TITLE_DESKTOP = {
  [ERROR_CODE]: {
    card: 'failure_payment_title',
    cash: 'failure_payment_title',
    ewallet: 'thank_you_title',
    bank_redirect: 'failure_payment_title',
    bank_transfer: 'thank_you_title'
  },
  [CLOSE_CODE]: {
    card: 'success_payment_title',
    cash: 'payment_complete',
    ewallet: 'payment_complete',
    bank_redirect: 'success_payment_title',
    bank_transfer: 'payment_complete'
  },
  [ACT_CODE]: {
    card: '',
    cash: 'thank_you_title',
    ewallet: 'thank_you_title',
    bank_redirect: '',
    bank_transfer: 'thank_you_title'
  },
  [CAN_CODE]: {
    card: 'payment_cancelled',
    cash: 'payment_cancelled',
    ewallet: 'payment_cancelled',
    bank_redirect: 'payment_cancelled',
    bank_transfer: 'payment_cancelled'
  },
  actPaymentWithInstructions: {
    card: '',
    cash: 'title_pending_payment_with_instructions',
    ewallet: 'title_pending_payment_with_instructions',
    bank_redirect: '',
    bank_transfer: 'title_pending_payment_with_instructions'
  },
  blocked: 'payment_unsuccessful',
  default: 'thankYouTexts.titles.thank_you_title'
};

export const EXPIRATION_TEXT = '____expiration';
export const THANK_YOU_TEXT_DESKTOP = {
  [ERROR_CODE]: {
    card: 'failure_payment_text',
    cash: 'failure_payment_text',
    ewallet: 'failure_payment_text',
    bank_redirect: 'failure_payment_text',
    bank_transfer: 'failure_payment_text'
  },
  [CLOSE_CODE]: {
    card: 'payment_completed',
    cash: '',
    ewallet: '',
    bank_redirect: 'payment_completed',
    bank_transfer: ''
  },
  [ACT_CODE]: {
    card: 'text_pending_capture_payment',
    cash: EXPIRATION_TEXT,
    ewallet: EXPIRATION_TEXT,
    bank_redirect: 'redirect_pending_text',
    bank_transfer: EXPIRATION_TEXT,
    delayed: 'text_pending_capture_payment',
    three_domain_secured_failed: 'three_ds_failed'
  },
  [CAN_CODE]: {
    card: 'payment_cancelled',
    cash: 'payment_cancelled',
    ewallet: 'payment_cancelled',
    bank_redirect: 'payment_cancelled',
    bank_transfer: 'payment_cancelled'
  },
  blocked: 'payment_declined'
};

export const MANDATORY_REQUIRED_FIELDS_CARD = [
  'number',
  'expiration_month',
  'expiration_year',
  'cvv',
  'name',
  'address'
];

export const BUTTON_TEXTS = {
  [CLOSE_CODE]: {
    cash: 'finish',
    card: 'finish',
    bank_transfer: 'finish',
    bank_redirect: 'finish',
    ewallet: 'finish'
  },
  [ACT_CODE]: {
    cash: 'finish',
    card: 'back_to_website',
    bank_transfer: 'finish',
    bank_redirect: 'back_to_website',
    ewallet: 'finish'
  },
  [ERROR_CODE]: {
    cash: 'cancel_and_go_back',
    card: 'cancel_and_go_back',
    bank_transfer: 'cancel_and_go_back',
    bank_redirect: 'cancel_and_go_back',
    ewallet: 'cancel_and_go_back'
  },
  [CAN_CODE]: {
    cash: 'cancel_and_go_back',
    card: 'cancel_and_go_back',
    bank_transfer: 'cancel_and_go_back',
    bank_redirect: 'cancel_and_go_back',
    ewallet: 'cancel_and_go_back'
  },
  blocked: 'back_to_website',
  makeAnotherPayment: 'make_another_payment'
};

export const FIXED_SIDE = {
  BUY: 'buy',
  SELL: 'sell'
};

export const PAYMENT_ERROR_QUERY_PARAM_NAME = 'payment_active_error';

export const CONDITIONAL_FIELDS_TYPES = {
  payment: 'payment',
  paymentMethodType: 'paymentMethodType',
  organization: 'organization'
};

export const CONDITIONAL_FIELDS_PATHS = {
  payment: 'payment.',
  paymentMethodType: 'payment_method_type.fields',
  organization: 'organization.'
};

export const CONDITIONAL_FIELD_ON_CHANGE_MAPPING = {
  [RequiredFieldsLocation.fields]: 'fields',
  [RequiredFieldsLocation.payment_method_options]: 'paymentMethodOptions',
  [RequiredFieldsLocation.payment_options]: 'customerRequiredFields'
};

export const CHECKOUT_FORM_NAME = 'checkoutForm';
export const CHECKOUT_FORM_CVV_NAME = 'checkoutCvvForm';

export const TYPES_DROPDOWN_SINGLE_PMT_TITLE = 'single_payment_method';

export const THREE_DS_ERROR_MESSAGES = {
  [CAN_CODE]: {
    title: 'errors.checkout.payment_cancel_status_1',
    text: 'errors.checkout.payment_cancel_status_2'
  },
  [ERROR_CODE]: {
    title: 'errors.checkout.payment_error_status_1',
    text: 'errors.checkout.payment_error_status_2'
  }
};

export const THREE_DS_ERROR_MESSAGES_CARD_TOKENIZATION = {
  [CAN_CODE]: {
    title: 'errors.card_tokenization.card_payment_error_status_1',
    text: 'errors.card_tokenization.card_payment_error_status_2'
  },
  [ERROR_CODE]: {
    title: 'errors.card_tokenization.card_payment_error_status_1',
    text: 'errors.card_tokenization.card_payment_error_status_2'
  },
  [ACT_CODE]: {
    title: 'errors.card_tokenization.card_payment_error_status_1',
    text: 'errors.card_tokenization.card_payment_error_status_2'
  }
};

export const SDK_EVENT_BY_PARAM = {
  mobileView: GA_CATEGORIES.MOBILE_VIEW,
  saveCardDefault: GA_CATEGORIES.SAVE_CARD_DEFAULT,
  hideCartItems: GA_CATEGORIES.HIDE_CART_ITEMS,
  hideOrderDetails: GA_CATEGORIES.HIDE_ORDER_DETAILS,
  hideSubmitButton: GA_CATEGORIES.HIDE_SUBMIT_BUTTON,
  waitOnPaymentConfirmation: GA_CATEGORIES.WAIT_ON_PAYMENT_CONFIRMATION,
  closeOnComplete: GA_CATEGORIES.CLOSE_ON_COMPLETE,
  waitOnPaymentRedirect: GA_CATEGORIES.WAIT_ON_PAYMENT_REDIRECT
};
